package com.example.mystybag.common.logic

import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.defines.UtilsActionsDefines.ACTION_NONE
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.AppViewModel.Companion.navigateTo
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.logic.base.FeatureManagers
import com.example.mystybag.core.model.AdditionalIcon
import com.example.mystybag.common.model.InternetTroubleshootingUIState
import com.example.mystybag.core.model.LinkModel
import com.example.mystybag.core.resources.SRC

class InternetTroubleshootingViewModel(context: AppContext): ChildViewModel<InternetTroubleshootingUIState>(context, InternetTroubleshootingUIState(
    issueText = listOf(
        LinkModel(text = sharedString(SR.strings.still_having_issue_contact_us).substring(0, sharedString(SR.strings.still_having_issue_contact_us).length - sharedString(SR.strings.contact_us).length), link = ""),
        LinkModel(text = sharedString(SR.strings.contact_us), "contact")
    )
), ACTION_NONE) {

    override fun onCreate() {
        navControls.backButtonVisible = false
        navControls.additionalIcons = listOf(AdditionalIcon(
            image   = SRC.images.navigation_close,
            action  = ::goBack
        ))
    }

    fun onContactUsClicked() {
        //uiThread { navigateTo(FeatureManagers.Help(true)) }
    }
}